import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/athletes")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb({ params }) {
      return {
        href: `/orgs/${params.slug}/athletes`,
        labelTranslationKey: "athletesPage.breadcrumb",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
